export function getMessageProp(messageKey,messageProps,messages){return(null==messageProps?void 0:messageProps[messageKey])||messages[messageKey]}